<template>
  <!-- page contact changes-->
  <div class="page-contact">
    <!-- <PreloaderPage /> -->
    <BannerPages
      :title="'contacts.titlebanner'"
      :descriptions="[
          $t('contacts.descriptbanner'),
      ]"
      :img="'/images/contact/banner-contact.png'"
      mainImageWidthDesk="543"
      mainImageHeightDesk="528"
      alt="Woman Trading on Cell phone..."
      :buttons="[
        {
          type: 'action',
          onClick: emailUs,
          class: 'second-button-medium-white',
          text: 'contacts.btn-banner',
        }
      ]"
    />
    <LazyFindUs :style="degrade"/>

    <client-only>
      <LazyInvestment
        :label="'open.title'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'open.link'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyFindUs from "~/components/contacts/FindUs.vue";

import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports';

const { getExternalUrl } = useExternalUrl();
const { t } = useI18n();

const nuxtImg = useImage();

const title = t("seo.contact-us.title");
const description = t("seo.contact-us.description");
const imgSeo = 'https://tradeview.eu/images/seo/07Contactus.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/contact/Contact-us-Gradient.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
    quality: 50,
    format: 'avif',
});

const degrade = computed(() => {
    return {
        '--degrade': `url('${optimizedDegrade}')`,
    };
});

/* const abrirChatHubSpot = () => {
    if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.open();
    } else {
        console.log('El widget de HubSpot Conversations no está disponible.');
    }
}; */

const emailUs = () => {
    window.location.href = 'mailto:support@tradeview.eu';
};
</script>
